import React, { Fragment } from 'react';
import AutocompleteSelect from 'chameleon/ui-stack/ui/forms/autocomplete-select';
import HorizontalTabsContainer from 'chameleon/ui-stack/ui/page/horizontal-tabs-container';
import HorizontalTabs from 'chameleon/ui-stack/ui/base/tabs/horizontal-tabs';
import {
  isFilterVisible,
  TYPE_FILTERS_STUDENT,
} from 'chameleon-src/components/assignments/constants';
import { ASSESSMENT_STATUSES } from 'chameleon-src/constants/assessmentStatus';
import useNavigation from 'chameleon/ui-stack/hooks/useNavigation';

const ResourceTypeFilter = ({
  router,
  studentPracticeProblems,
  pdfAssignmentsFF,
  afamEp26FullLaunchP1FF,
  subject,
  userSubjects = [],
  isStudent,
}) => {
  const { queryParams, pushParamsToHistory, location } = useNavigation({
    router,
  });

  const subjectInfo =
    userSubjects &&
    userSubjects.find((s) => parseInt(s.id, 10) === parseInt(subject, 10));

  const { status = 'assigned', type: resourceType = '' } = queryParams || {};
  const typeFilters = TYPE_FILTERS_STUDENT(
    studentPracticeProblems,
    pdfAssignmentsFF,
    status?.split(',')?.find((s) => ASSESSMENT_STATUSES.includes(s)),
    subjectInfo?.subjectProgram?.toLowerCase?.(),
  );
  const filterDropdownOptions = typeFilters.map((type) => ({
    label: type.name,
    value: type.value,
  }));

  const onSelectChange = (option) => {
    const mappedOption = typeFilters.find(
      (type) => type.value === option.value,
    );
    pushParamsToHistory(
      { type: mappedOption.value, ...(mappedOption?.params || {}) },
      location.pathname,
      ['page'],
    );
  };

  const selectValue = resourceType
    ? filterDropdownOptions.find((type) => type.value === resourceType)
    : filterDropdownOptions?.[0];
  return (
    <Fragment>
      <div className="desktop:block mobile:hidden">
        <HorizontalTabsContainer
          noMargin
          leftContainer={
            <HorizontalTabs
              tabs={typeFilters
                .filter((filter) =>
                  isFilterVisible(
                    Number(subject),
                    status,
                    filter,
                    isStudent,
                    afamEp26FullLaunchP1FF,
                  ),
                )
                .map((filter) => {
                  const isActive = Boolean(
                    filter.value === resourceType ||
                      (filter?.values?.length &&
                        !filter.values.includes(resourceType)),
                  );

                  return {
                    name: filter.name,
                    onClick: () => {
                      pushParamsToHistory(
                        { type: filter.value, ...(filter?.params || {}) },
                        location.pathname,
                        ['page'],
                      );
                    },
                    isActive,
                    otherProps: {
                      'data-value': filter.value,
                      ...(filter.trackingId && {
                        'data-tracking-id': filter.trackingId,
                      }),
                    },
                  };
                })}
              accessibility={{
                ariaLabel: 'Assignment tabs',
              }}
            />
          }
        />
      </div>
      <div className="desktop:hidden mobile:block mx-8.4">
        <AutocompleteSelect
          className="Select-root"
          inputClassName="h-12.2 text-gray-600"
          options={filterDropdownOptions}
          value={selectValue}
          onChange={onSelectChange}
        />
      </div>
    </Fragment>
  );
};

export default ResourceTypeFilter;
